import type { ReactNode } from "react";
import {
  Bot,
  Boxes,
  CirclePlay,
  LogOut,
  MessagesSquare,
  Network,
  Settings,
  Workflow,
} from "lucide-react";
import type { SessionUser } from "../../shared/types";

export type AppView = "chat" | "builder" | "workflows" | "agents" | "runs" | "settings";

interface AppShellProps {
  user: SessionUser;
  view: AppView;
  onViewChange: (view: AppView) => void;
  onLogout: () => void;
  children: ReactNode;
}

const navItems: Array<{ view: AppView; label: string; icon: typeof Workflow }> = [
  { view: "chat", label: "Mesa", icon: MessagesSquare },
  { view: "builder", label: "Editor", icon: Network },
  { view: "workflows", label: "Workflows", icon: Workflow },
  { view: "agents", label: "Agentes", icon: Bot },
  { view: "runs", label: "Execuções", icon: CirclePlay },
  { view: "settings", label: "Configurações", icon: Settings },
];

export function AppShell({
  user,
  view,
  onViewChange,
  onLogout,
  children,
}: AppShellProps) {
  return (
    <div className="app-shell">
      <aside className="global-rail" aria-label="Navegação principal">
        <button
          className="rail-brand"
          title="Go Win Pro"
          aria-label="Go Win Pro"
          onClick={() => onViewChange("builder")}
        >
          <Boxes size={21} />
        </button>
        <nav>
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.view}
                className={`rail-button ${view === item.view ? "is-active" : ""}`}
                aria-label={item.label}
                title={item.label}
                onClick={() => onViewChange(item.view)}
              >
                <Icon size={19} />
              </button>
            );
          })}
        </nav>
        <div className="rail-spacer" />
        <div className="rail-avatar" title={`${user.name} · ${user.email}`}>
          {user.name.slice(0, 1).toUpperCase()}
        </div>
        <button className="rail-button" aria-label="Sair" title="Sair" onClick={onLogout}>
          <LogOut size={18} />
        </button>
      </aside>
      <div className="app-surface">{children}</div>
    </div>
  );
}
